import { render } from "./AssignUser.vue?vue&type=template&id=6ee4e896&scoped=true"
import script from "./AssignUser.vue?vue&type=script&lang=js"
export * from "./AssignUser.vue?vue&type=script&lang=js"

import "./AssignUser.vue?vue&type=style&index=0&id=6ee4e896&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee4e896"]])

export default __exports__